export default {"src":"/_next/static/media/360-degree.e6f7c0fd.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};